<template>
  <aside class="auth-app-promo" aria-label="MentorMe mobile app">
    <div class="auth-app-promo__card">
      <div class="auth-app-promo__badge">
        <svg class="auth-app-promo__badge-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <rect x="7" y="2" width="10" height="20" rx="2" />
          <line x1="11" y1="18" x2="13" y2="18" />
        </svg>
        <span>{{ $t('authAppTitle') }}</span>
      </div>

      <h2 class="auth-app-promo__title">{{ $t('authAppHeroTitle') }}</h2>
      <p class="auth-app-promo__subtitle">{{ $t('authAppHeroSubtitle') }}</p>

      <div class="auth-app-promo__phones" aria-hidden="true">
        <div class="auth-app-promo__phone auth-app-promo__phone--back">
          <div class="auth-app-promo__phone-frame">
            <div class="auth-app-promo__phone-notch" />
            <div class="auth-app-promo__phone-screen">
              <img :src="screenshotAi" alt="" />
            </div>
          </div>
        </div>
        <div class="auth-app-promo__phone auth-app-promo__phone--front">
          <div class="auth-app-promo__phone-frame">
            <div class="auth-app-promo__phone-notch" />
            <div class="auth-app-promo__phone-screen">
              <img :src="screenshotMain" alt="" />
            </div>
          </div>
        </div>
      </div>

      <div class="auth-app-promo__stores">
        <a
          class="auth-app-promo__store-col"
          :href="appStoreUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span class="auth-app-promo__qr-wrap">
            <img
              class="auth-app-promo__qr"
              :src="appStoreQrUrl"
              width="96"
              height="96"
              :alt="$t('authAppQrAlt')"
              loading="lazy"
            />
          </span>
          <span class="auth-app-promo__store-label">
            <svg class="auth-app-promo__store-icon" viewBox="0 0 24 24" aria-hidden="true">
              <path
                fill="currentColor"
                d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"
              />
            </svg>
            App Store
          </span>
        </a>

        <a
          v-if="googlePlayUrl"
          class="auth-app-promo__store-col"
          :href="googlePlayUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span class="auth-app-promo__qr-wrap">
            <img
              class="auth-app-promo__qr"
              :src="googlePlayQrUrl"
              width="96"
              height="96"
              :alt="$t('authAppPlayQrAlt')"
              loading="lazy"
            />
          </span>
          <span class="auth-app-promo__store-label">
            <svg class="auth-app-promo__store-icon" viewBox="0 0 24 24" aria-hidden="true">
              <path
                fill="currentColor"
                d="M3.609 1.814L13.792 12 3.61 22.186a1.003 1.003 0 01-.61-.92V2.734a1.003 1.003 0 01.609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.198l2.807 1.626a1 1 0 010 1.73l-2.808 1.626L15.206 12l2.492-2.491zM5.864 2.658L16.8 8.99l-2.302 2.302-8.634-8.634z"
              />
            </svg>
            Google Play
          </span>
        </a>
      </div>
    </div>
  </aside>
</template>

<script>
import {
  MENTORME_APP_STORE_URL,
  MENTORME_GOOGLE_PLAY_URL,
  getAppStoreQrImageUrl,
  getGooglePlayQrImageUrl,
} from '@/constants/authAppLinks';
import screenshotMain from '@/assets/mobile_screen_1.svg';
import screenshotAi from '@/assets/mobile_screen_2.svg';

export default {
  name: 'AuthAppPromo',
  data() {
    return {
      appStoreUrl: MENTORME_APP_STORE_URL,
      googlePlayUrl: MENTORME_GOOGLE_PLAY_URL,
      appStoreQrUrl: getAppStoreQrImageUrl(112),
      googlePlayQrUrl: MENTORME_GOOGLE_PLAY_URL ? getGooglePlayQrImageUrl(112) : '',
      screenshotMain,
      screenshotAi,
    };
  },
};
</script>
